var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "task-base-line-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "task-base-line",
        style: { height: _vm.baselineHgt + "px" }
      },
      [
        _vm._l(_vm.clockMarkerList, function(clockMarker) {
          return [
            _c("div", {
              staticClass: "clock",
              class: { special: clockMarker.special },
              style: { left: clockMarker.left + "px" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clock-text",
                class: { special: clockMarker.special },
                style: { left: clockMarker.textLeft + "px" }
              },
              [_vm._v(_vm._s(clockMarker.text))]
            )
          ]
        }),
        _vm._v(" "),
        _vm.dayOffMarker != null
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.dayOffMarker.title,
                  effect: "light",
                  placement: "top-start"
                }
              },
              [
                _c("div", {
                  staticClass: "dayoff",
                  style: {
                    left: _vm.dayOffMarker.left + "px",
                    width: _vm.dayOffMarker.width + "px",
                    height: _vm.baselineHgt + "px"
                  }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.totalWorkMinutes != null
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  content: "工作时长",
                  effect: "light",
                  placement: "top-start"
                }
              },
              [
                _c("div", { staticClass: "minutes" }, [
                  _vm._v(_vm._s(_vm.totalWorkMinutes) + " 分钟")
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.signinMarker != null
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.signinMarker.title,
                  effect: "dark",
                  placement: "top-start"
                }
              },
              [
                _c("div", {
                  staticClass: "sign in",
                  style: { left: _vm.signinMarker.left + "px" }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.signoutMarker != null
          ? _c(
              "el-tooltip",
              {
                attrs: {
                  content: _vm.signoutMarker.title,
                  effect: "dark",
                  placement: "top-start"
                }
              },
              [
                _c("div", {
                  staticClass: "sign out",
                  style: { left: _vm.signoutMarker.left + "px" }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.taskMarkers, function(taskMarker) {
          return [
            taskMarker.visible
              ? _c(
                  "el-tooltip",
                  { attrs: { effect: "dark", placement: "top-start" } },
                  [
                    _c("div", {
                      staticStyle: { "line-height": "30px" },
                      attrs: { slot: "content" },
                      domProps: { innerHTML: _vm._s(taskMarker.title) },
                      slot: "content"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "task",
                        style: {
                          left: taskMarker.left + "px",
                          width: taskMarker.width + "px",
                          bottom: taskMarker.bottom + "px"
                        },
                        on: {
                          click: function($event) {
                            _vm.clickHandlerProxy(
                              taskMarker.taskId,
                              taskMarker.allNodes
                            )
                          }
                        }
                      },
                      [
                        _vm._l(taskMarker.phases, function(phase) {
                          return [
                            _c("div", {
                              staticClass: "phase",
                              class: phase.cssClass,
                              style: {
                                left: phase.left + "px",
                                width: phase.width + "px"
                              }
                            })
                          ]
                        }),
                        _vm._v(" "),
                        _vm.isInvalidated(taskMarker.taskId)
                          ? _c("img", {
                              directives: [
                                {
                                  name: "resc-url",
                                  rawName: "v-resc-url",
                                  value: "/image/red-cross.png",
                                  expression: "'/image/red-cross.png'"
                                }
                              ],
                              staticClass: "invalidated"
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53115cfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53115cfe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/task/TaskLine.vue
// module id = 4643
// module chunks = 0